/**
 * @export CategoryConfigModel
 * @export CategoryConfigBuilder
 */

export function CategoryConfigModel(config, sponsorId, tags, locale) {
    this.config = config || "";
    this.sponsorId = sponsorId || "";
    this.tags = tags || "";
    this.locale = locale;

    this.getParams = () => {
        var params = {};

        if (this.config)
            params.config = this.config;

        if (this.sponsorId)
            params.sponsorId = this.sponsorId;

        if (this.tags)
            params.tags = this.tags;

        if (this.locale)
            params.device_locale = this.locale;

        return params;
    };
}

export function CategoryConfigBuilder() {
    this.categoryConfig = new CategoryConfigModel();

    this.create = () => {
        return this.categoryConfig;
    };

    this.setConfig = (config) => {
        this.categoryConfig.config = config;
        return this;
    };

    this.setSponsorId = (sponsorId) => {
        this.categoryConfig.sponsorId = sponsorId;
        return this;
    };

    this.setTags = (tags) => {
        this.categoryConfig.tags = tags;
        return this;
    };

    this.setLocale = (locale) => {
        this.categoryConfig.locale = locale;
        return this;
    };
}
